import * as React from 'react';
import { getMarkJS } from 'owa-mark/lib/utils/constants';

export interface DataProps {
    readonly highlightTerms: string[];
    readonly highlightType?: HighlightType;
    readonly children?: React.ReactNode;
}

export function getCurrentQueryTerms(queryText: string): string[] {
    if (queryText) {
        return queryText.split(' ');
    }
    return undefined;
}

export const enum HighlightType {
    Classic,
    Bold,
}

export default function HighLightTerms(props: DataProps) {
    const elementToMark = React.useRef<HTMLElement>();
    React.useEffect(() => {
        if (!props.highlightTerms) {
            getMarkJS().then(markJs => {
                const marker = markJs.call(markJs, elementToMark.current);
                marker.unmark();
            });
        }
    }, [props.highlightTerms]);
    const highlightTerms = (element: HTMLElement, terms: string[]): void => {
        elementToMark.current = element;
        if (element && terms) {
            getMarkJS().then(markJs => {
                const marker = markJs.call(markJs, element);
                if (props.highlightType && props.highlightType === HighlightType.Bold) {
                    marker.mark(terms, { element: 'b' });
                } else {
                    marker.mark(terms);
                }
            });
        }
    };
    return <div ref={ref => highlightTerms(ref, props.highlightTerms)}>{props.children}</div>;
}
